export const alphanumeric = /^[a-zA-Z0-9 ]*$/gm
